import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/training-course-assistant-management`;

export const trainingCourseAssistantManagementRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  edit: `${baseRoute}/edit/:trainingCourseAssistantId`,
} as const;

export type ITrainingCourseAssistantManagementRouteParams =
  IExtractRouteParamMap<typeof trainingCourseAssistantManagementRoutesObj>;

export const trainingCourseAssistantManagementPath = createPaths<
  typeof trainingCourseAssistantManagementRoutesObj,
  ITrainingCourseAssistantManagementRouteParams
>(trainingCourseAssistantManagementRoutesObj);
